export default "__VITE_ASSET__Cyij5nD8__"